module.exports = __webpack_public_path__ + "static/media/Branding-Identity-Mockup-Vol11.06ed8354.jpg";